import { useDynamicConfig } from '@statsig/react-bindings';

/**
 * Statsig `enable_test_kit_subscription` public_config flag.
 * Off means every test renders the pre-subscription single-CTA card
 * regardless of Strapi's `isSubscriptionAvailable`.
 */
export const useIsTestKitSubscriptionEnabled = (): boolean => {
  const publicConfig = useDynamicConfig('public_config');
  return publicConfig.get('enable_test_kit_subscription', false);
};
